import { render, staticRenderFns } from "./RequestHistory.vue?vue&type=template&id=d4b1a68c&scoped=true&"
import script from "./RequestHistory.vue?vue&type=script&lang=ts&"
export * from "./RequestHistory.vue?vue&type=script&lang=ts&"
import style0 from "./RequestHistory.vue?vue&type=style&index=0&id=d4b1a68c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b1a68c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
